<template>
  <button type="button" class="border-2 p-3 my-2 border-blue-brand align-middle font-primary font-extrabold text-12 md:text-14 text-center uppercase tracking-1/4 inline-block" @click.prevent="print">
    <svg-sprite href="icon-print" class="inline-block w-5 h-5 mr-2"></svg-sprite>
    <slot>Print this page</slot>
  </button>
</template>

<script>
export default {
  methods: {
    print() {
      window.print();
    }
  }
}
</script>
